class DrUpcoming extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.signal = this.controller.signal;
    this.key = 'donreloj-arrival-reminders-v1';
    this.labels = JSON.parse(this.querySelector('[data-dru-labels]').textContent);
    this.dialog = this.querySelector('#DrUpcoming');
    this.notificationsDialog = this.querySelector('#DrNotifications');
    this.items = this.read();
    this.render();
    this.enableButtons();
    document.addEventListener('click', event => this.click(event), { signal: this.signal });
    document.addEventListener('change', event => { if (event.target.matches('[data-dru-variant]')) this.syncButtons(); }, { signal: this.signal });
    document.addEventListener('shopify:section:load', () => {
      this.enableButtons();
      this.render();
      this.observeSections();
    }, { signal: this.signal });
    window.addEventListener('storage', event => { if (event.key === this.key) { this.items = this.read(); this.render(); } }, { signal: this.signal });
    window.addEventListener('focus', () => this.check(), { signal: this.signal });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this.check(); }, { signal: this.signal });
    this.dialog.addEventListener('close', () => { this.updateNav(); if (!this.notificationsDialog.open) this.opener?.focus(); }, { signal: this.signal });
    this.notificationsDialog.addEventListener('close', () => {
      this.syncNotificationButtons();
      if (!this.dialog.open) this.notificationOpener?.focus();
    }, { signal: this.signal });
    this.observeSections();
    this.timer = window.setInterval(() => { if (!document.hidden) this.check(); }, 120000);
    this.check();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    clearInterval(this.timer);
    this.dialog?.close();
    this.notificationsDialog?.close();
  }
  enableButtons() {
    document.querySelectorAll('[data-dru-save], [data-dru-notifications-open]').forEach(button => { button.hidden = false; });
  }
  read() {
    try {
      const saved = JSON.parse(localStorage.getItem(this.key) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.filter(item => item && (/^\d+$/.test(item.id) || this.isDemo(item)) && /^[a-z0-9-]+$/.test(item.handle) && typeof item.title === 'string').slice(0, 50);
    } catch { return []; }
  }
  write(next) {
    try { localStorage.setItem(this.key, JSON.stringify(next)); this.items = next; return true; }
    catch { this.say(this.labels.storage_error); return false; }
  }
  say(message) {
    const target = this.querySelector(this.notificationsDialog?.open ? '[data-dru-notification-status]' : this.dialog.open ? '[data-dru-feedback]' : '[data-dru-status]');
    target.textContent = message;
  }
  selected(card) {
    const input = card.querySelector('[data-dru-variant]');
    const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
    const image = this.safeImage(option.dataset.druImage || card.querySelector('.dru-image img')?.src);
    return { id: input.value, handle: card.dataset.handle, title: card.dataset.title, variant: input.tagName === 'SELECT' ? option.textContent : '', image, demo: card.hasAttribute('data-dru-demo'), arrived: false, announced: false, arrivedAt: 0, notificationRead: false };
  }
  isDemo(item) {
    return item.demo === true && item.id === 'demo-oro-rosa-negro';
  }
  simulateDemo(reset = false) {
    const latest = this.read();
    const demo = latest.find(item => this.isDemo(item));
    if (!demo || (!reset && demo.arrived)) return;
    const next = latest.map(item => this.isDemo(item) ? { ...item, arrived: !reset, announced: !reset, arrivedAt: reset ? 0 : Date.now(), notificationRead: false } : item);
    if (!this.write(next)) return;
    this.render();
    this.querySelector('[data-dru-toast]').hidden = reset;
    if (reset) { this.say(this.labels.demo_waiting); return; }
    this.querySelector('[data-dru-feedback]').textContent = '';
    if (this.dialog.open) this.dialog.close();
    this.notifyArrival(demo);
  }
  click(event) {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-dru-demo-arrive]')) { this.simulateDemo(); return; }
    if (event.target.closest('[data-dru-demo-reset]')) { this.simulateDemo(true); return; }
    if (event.target.closest('[data-dru-mark-read]')) { this.markRead(); return; }
    const notification = event.target.closest('[data-dru-notification-id]');
    if (notification && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) this.markRead(notification.dataset.druNotificationId, false);
    const notificationsOpen = event.target.closest('[data-dru-notifications-open]');
    if (notificationsOpen) {
      this.notificationOpener = notificationsOpen;
      if (this.dialog.open) this.dialog.close();
      this.querySelector('[data-dru-toast]').hidden = true;
      this.notificationsDialog.showModal(); this.renderNotifications(); this.check(); return;
    }
    if (event.target.closest('[data-dru-notifications-close]')) { this.notificationsDialog.close(); return; }
    const open = event.target.closest('[data-dru-open]');
    if (open && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      if (this.notificationsDialog.open) this.notificationsDialog.close();
      event.preventDefault(); this.opener = open; this.dialog.showModal(); this.updateNav('upcoming'); this.render(); this.check(); return;
    }
    if (event.target.closest('[data-dru-close]')) { this.dialog.close(); return; }
    if (event.target === this.dialog || event.target === this.notificationsDialog) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
      return;
    }
    if (event.target.closest('[data-dru-dismiss]')) { this.querySelector('[data-dru-toast]').hidden = true; return; }
    const remove = event.target.closest('[data-dru-remove]');
    const save = event.target.closest('[data-dru-save]');
    if (!remove && !save) return;
    this.items = this.read();
    const chosen = save ? this.selected(save.closest('[data-dru-card]')) : null;
    const id = remove?.dataset.druRemove || chosen.id;
    const exists = this.items.some(item => item.id === id);
    if (!exists && this.items.length >= 50) { this.say(this.labels.limit); return; }
    const next = exists ? this.items.filter(item => item.id !== id) : [...this.items, chosen];
    if (this.write(next)) {
      this.render(); this.say(exists ? this.labels.removed : this.labels.added);
      const feedback = save?.closest('[data-dru-card]')?.querySelector('[data-dru-save-feedback]');
      if (feedback) { feedback.textContent = exists ? this.labels.removed : this.labels.added; feedback.hidden = false; }
      if (remove) this.querySelector('[data-dru-remove]')?.focus();
      if (!exists) this.check(true);
    }
  }
  productURL(item) {
    const root = this.dataset.root.endsWith('/') ? this.dataset.root : `${this.dataset.root}/`;
    if (this.isDemo(item)) return new URL(`${root}collections/lo-proximo-por-llegar`, location.origin);
    return new URL(`${root}products/${encodeURIComponent(item.handle)}?variant=${encodeURIComponent(item.id)}`, location.origin);
  }
  safeImage(value) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
    } catch { return ''; }
  }
  imageFor(item) {
    return this.safeImage(item.image) || (this.isDemo(item) ? this.safeImage(document.querySelector('[data-dru-demo] .dru-image img')?.src) : '');
  }
  notifications() {
    return this.items.filter(item => item.announced).sort((a, b) => (Number(b.arrivedAt) || 0) - (Number(a.arrivedAt) || 0));
  }
  markRead(id, render = true) {
    const next = this.read().map(item => item.announced && (!id || item.id === id) ? { ...item, notificationRead: true } : item);
    if (!this.write(next)) return;
    if (render) this.renderNotifications(); else this.syncNotificationButtons();
    if (!id) this.say(this.labels.marked_read);
  }
  syncNotificationButtons() {
    const count = this.notifications().filter(item => !item.notificationRead).length;
    document.querySelectorAll('[data-dru-notifications-open]').forEach(button => {
      button.setAttribute('aria-expanded', String(this.notificationsDialog.open));
      button.setAttribute('aria-label', count ? `${this.labels.notifications_title}: ${count} ${this.labels.unread}` : this.labels.notifications_title);
    });
    document.querySelectorAll('[data-dru-unread-count]').forEach(node => { node.textContent = count; node.hidden = count === 0; });
  }
  renderNotifications() {
    const items = this.notifications();
    const list = this.querySelector('[data-dru-notification-list]');
    // Keep focus on the same notification when a background stock check refreshes the list.
    const focusedId = list.contains(document.activeElement) ? document.activeElement.closest('[data-dru-notification-id]')?.dataset.druNotificationId : null;
    list.replaceChildren();
    for (const item of items) {
      const row = document.createElement('li'); row.className = 'drn-item'; row.dataset.unread = String(!item.notificationRead);
      const link = document.createElement('a'); link.href = this.productURL(item).href; link.dataset.druNotificationId = item.id;
      if (this.isDemo(item)) link.dataset.druOpen = '';
      const thumb = document.createElement('span'); thumb.className = 'drn-thumb';
      const source = this.imageFor(item);
      if (source) {
        const img = document.createElement('img'); img.src = source; img.alt = ''; img.width = 80; img.height = 100; img.loading = 'lazy'; thumb.append(img);
      } else { thumb.textContent = 'DR'; thumb.setAttribute('aria-hidden', 'true'); }
      const content = document.createElement('span'); content.className = 'drn-content';
      const heading = document.createElement('span'); heading.className = 'drn-item-heading';
      const title = document.createElement('strong'); title.textContent = item.title; heading.append(title);
      if (!item.notificationRead) { const badge = document.createElement('span'); badge.className = 'drn-new'; badge.textContent = this.labels.new; heading.append(badge); }
      content.append(heading);
      if (item.variant) { const variant = document.createElement('span'); variant.className = 'drn-variant'; variant.textContent = item.variant; content.append(variant); }
      const message = document.createElement('span'); message.className = 'drn-message'; message.textContent = this.isDemo(item) ? this.labels.demo_arrived : this.labels.arrived;
      const cta = document.createElement('span'); cta.className = 'drn-cta'; cta.textContent = `${this.isDemo(item) ? this.labels.view_demo : this.labels.view_product} ↗`;
      content.append(message, cta); link.append(thumb, content); row.append(link); list.append(row);
    }
    this.querySelector('[data-dru-notification-empty]').hidden = items.length > 0;
    this.querySelector('[data-dru-mark-read]').disabled = !items.some(item => !item.notificationRead);
    this.syncNotificationButtons();
    if (focusedId) Array.from(list.querySelectorAll('[data-dru-notification-id]')).find(link => link.dataset.druNotificationId === focusedId)?.focus();
  }
  notifyArrival(item) {
    const image = this.querySelector('[data-dru-toast-image]'); const source = this.imageFor(item);
    image.hidden = !source;
    if (source) image.src = source; else image.removeAttribute('src');
    this.querySelector('[data-dru-toast-title]').textContent = item.title;
    const message = this.isDemo(item) ? this.labels.demo_arrived : this.labels.arrived;
    this.querySelector('[data-dru-toast-text]').textContent = message;
    this.querySelector('[data-dru-toast]').hidden = false;
    this.say(`${item.title}. ${message}`);
  }
  syncButtons() {
    document.querySelectorAll('[data-dru-save]').forEach(button => {
      const item = this.selected(button.closest('[data-dru-card]'));
      const saved = this.items.some(current => current.id === item.id);
      button.setAttribute('aria-pressed', String(saved));
      button.querySelector('span').textContent = saved ? this.labels.saved : this.labels.save;
    });
    document.querySelectorAll('[data-dru-demo]').forEach(card => {
      const saved = this.items.find(item => this.isDemo(item));
      card.querySelector('.dru-demo-controls').hidden = false;
      card.querySelector('[data-dru-demo-arrive]').disabled = !saved || saved.arrived;
      card.querySelector('[data-dru-demo-reset]').hidden = !saved?.arrived;
      card.querySelector('[data-dru-demo-state]').textContent = saved?.arrived ? this.labels.demo_arrived : saved ? this.labels.demo_waiting : this.labels.demo_start;
    });
  }
  render() {
    this.syncButtons();
    const list = this.querySelector('[data-dru-reminders]');
    list.replaceChildren();
    for (const item of this.items) {
      const row = document.createElement('div'); row.className = 'dru-reminder';
      const content = document.createElement('div');
      const title = document.createElement('a'); title.href = this.productURL(item).href; title.textContent = item.title + (item.variant ? ` · ${item.variant}` : '');
      const status = document.createElement('p'); status.textContent = this.isDemo(item) ? (item.arrived ? this.labels.demo_arrived : this.labels.demo_waiting) : (item.arrived ? this.labels.arrived : this.labels.waiting);
      status.className = item.arrived ? 'dru-arrived' : '';
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.druRemove = item.id; remove.textContent = '×'; remove.setAttribute('aria-label', `${this.labels.remove}: ${item.title}`);
      content.append(title, status); row.append(content, remove); list.append(row);
    }
    this.querySelector('[data-dru-count]').textContent = this.items.length;
    this.querySelector('[data-dru-no-reminders]').hidden = this.items.length > 0;
    this.renderNotifications();
  }
  async check(force = false) {
    if (this.busy || (!force && Date.now() - (this.checkedAt || 0) < 60000)) return;
    this.busy = true; this.checkedAt = Date.now();
    this.items = this.read();
    const handles = [...new Set(this.items.filter(item => !this.isDemo(item)).map(item => item.handle))];
    const results = new Map();
    let failed = false;
    try {
      for (let i = 0; i < handles.length; i += 4) {
        await Promise.all(handles.slice(i, i + 4).map(async handle => {
          const item = this.items.find(current => current.handle === handle);
          if (!item) return;
          const url = this.productURL(item); url.searchParams.delete('variant'); url.searchParams.set('view', 'dr-arrival');
          try {
            const response = await fetch(url, { signal: AbortSignal.any([this.signal, AbortSignal.timeout(10000)]), credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('availability');
            const data = await response.json();
            if (!Array.isArray(data.variants)) throw new Error('availability');
            for (const variant of data.variants) if (typeof variant.arrived === 'boolean') results.set(String(variant.id), { arrived: variant.arrived, image: this.safeImage(variant.image), title: typeof data.title === 'string' ? data.title : '' });
          } catch (error) { if (error.name !== 'AbortError') failed = true; }
        }));
      }
      if (this.signal.aborted) return;
      const latest = this.read();
      let newlyArrived;
      const next = latest.map(item => {
        const result = results.get(item.id);
        if (!result) return item;
        const firstArrival = result.arrived && !item.announced;
        const updated = { ...item, title: result.title || item.title, image: result.image || item.image, arrived: result.arrived, announced: result.arrived || item.announced, arrivedAt: firstArrival ? Date.now() : item.arrivedAt, notificationRead: firstArrival ? false : item.notificationRead };
        if (firstArrival) newlyArrived = updated;
        return updated;
      });
      if (next.length && this.write(next)) {
        this.render();
        if (newlyArrived) this.notifyArrival(newlyArrived);
      }
      if (failed && (this.dialog.open || this.notificationsDialog?.open)) this.say(this.labels.check_error);
    } finally { this.busy = false; }
  }
  updateNav(active) {
    const selected = active || (location.pathname.includes('/collections/lo-proximo-por-llegar') ? 'upcoming' : this.activeSection);
    document.querySelectorAll('[data-dru-nav]').forEach(link => {
      if (link.dataset.druNav === selected) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
    });
  }
  observeSections() {
    this.observer?.disconnect();
    const stories = document.querySelector('donreloj-stories');
    const categories = document.querySelector('.drf');
    if (stories) stories.id = 'dr-historias';
    if (categories) categories.id = 'dr-categorias';
    this.observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) {
        this.activeSection = entry.target === stories ? 'stories' : 'categories';
        if (!this.dialog.open) this.updateNav();
      }
    }, { rootMargin: '-15% 0px -45% 0px', threshold: 0 });
    if (stories) this.observer.observe(stories);
    if (categories) this.observer.observe(categories);
    this.updateNav();
  }
}
if (!customElements.get('dr-upcoming')) customElements.define('dr-upcoming', DrUpcoming);


